module.exports = __webpack_public_path__ + "static/img/whitetitles.ee58c8f7.png";